import { useState } from 'react'
import { Link, NavLink, useLocation } from 'react-router'

const NAV_ITEMS = [
  { to: '/platform', label: 'Platform' },
  { to: '/solutions', label: 'Solutions' },
  { to: '/integrations', label: 'Integrations' },
  { to: '/nex', label: 'Nex' },
  { to: '/security', label: 'Security' },
]

export function SiteHeader() {
  const [open, setOpen] = useState(false)
  const { pathname } = useLocation()
  const onHome = pathname === '/'

  const linkClass = ({ isActive }: { isActive: boolean }) =>
    `rounded-sm px-3 py-2 text-sm font-semibold transition-colors duration-state ${
      isActive ? 'text-signal' : 'text-ink-mute hover:text-ink'
    }`

  return (
    <>
      <a
        href="#main"
        className="sr-only focus:not-sr-only focus:absolute focus:left-4 focus:top-4 focus:z-[60] focus:rounded-sm focus:bg-signal focus:px-4 focus:py-2 focus:text-sm focus:font-bold focus:text-base-950"
      >
        Skip to main content
      </a>
      <header className="sticky top-0 z-50 border-b border-base-line bg-base-950/85 backdrop-blur-md">
        <div className="mx-auto flex h-16 w-full max-w-7xl items-center gap-6 px-5 sm:px-8">
          <Link to="/" className="flex items-center gap-2.5" aria-label="TLDNXS by Esotech: home">
            <img
              src="/images/tldnxs-blue-wht-logo.png"
              alt=""
              width={26}
              height={30}
              className="h-7 w-auto"
            />
            <span className="font-display text-[14px] font-semibold tracking-[0.1em] text-ink">
              TLDNXS
            </span>
            <span className="hidden font-mono text-[10px] uppercase tracking-[0.18em] text-ink-dim sm:inline">
              by Esotech
            </span>
          </Link>

          <nav aria-label="Primary" className="ml-auto hidden items-center gap-1 lg:flex">
            {NAV_ITEMS.map((item) => (
              <NavLink key={item.to} to={item.to} className={linkClass}>
                {item.label}
              </NavLink>
            ))}
            {onHome ? (
              <Link to="/walkthrough" className="btn-ghost ml-3 px-3 py-2 text-sm">
                Book a walkthrough
              </Link>
            ) : (
              <Link to="/walkthrough" className="btn-primary-nav ml-3">
                Book a walkthrough
              </Link>
            )}
          </nav>

          <button
            type="button"
            className="ml-auto inline-flex items-center gap-2 rounded-sm border border-base-linebright px-3 py-2 text-sm font-semibold text-ink lg:hidden"
            aria-expanded={open}
            aria-controls="mobile-nav"
            onClick={() => setOpen((v) => !v)}
          >
            <span aria-hidden="true">{open ? '✕' : '☰'}</span>
            Menu
          </button>
        </div>

        {open && (
          <nav
            id="mobile-nav"
            aria-label="Mobile"
            className="border-t border-base-line bg-base-950 px-5 py-4 lg:hidden"
          >
            <ul className="flex flex-col gap-1">
              {NAV_ITEMS.map((item) => (
                <li key={item.to}>
                  <NavLink
                    to={item.to}
                    className={({ isActive }) =>
                      `block rounded-sm px-3 py-2.5 text-sm font-semibold ${
                        isActive ? 'bg-base-800 text-signal' : 'text-ink-mute'
                      }`
                    }
                    onClick={() => setOpen(false)}
                  >
                    {item.label}
                  </NavLink>
                </li>
              ))}
              <li className="pt-2">
                <Link
                  to="/walkthrough"
                  className="btn-primary w-full"
                  onClick={() => setOpen(false)}
                >
                  Book a walkthrough
                </Link>
              </li>
            </ul>
          </nav>
        )}
      </header>
    </>
  )
}
